import { columnsheadId } from '../../universal/columnshead';
import WebUniversalNewEx, { WUExtendPropsType } from '../../system/WebUniversalNewEx';
import ExpandDetailEdit from './ExpandDetailEdit';
import { useEffect, useRef } from 'react';
import { Tooltip } from 'antd';

export default function ExpandDetail(props: any) {

    const ref = useRef<any>(undefined);
    /** api服务id */
    const apiId = 'expandDetail';

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            // handleChangeOne = ref.current.handleChangeOne;
        }
        //同步获取数据 async - await
        const fetchData = async () => {
        }

        fetchData();
        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); //初始化数据

    //表头
    const columnsHead = [
        {
            title: '菜式',
            dataIndex: 'foodName',
            render: (text: any, record: any) => {
                return (
                    <div>{record.menuWarehouse.foodName}</div>
                )
            }
        },
        {
            title: '需求类型',
            dataIndex: 'expandCategoryName',
            render: (text: any, record: any) => {
                return (
                    <div>{record?.expandType?.expandCategory?.expandCategoryName}</div>
                )
            }
        },
        {
            title: '需求内容',
            dataIndex: 'expandTypeName',
            width: 300,
            render: (text: any, record: any) => {
                let expandTypeName = record?.expandType?.expandTypeName;
                return (
                    <Tooltip placement="topLeft" title={expandTypeName}>{
                        (typeof expandTypeName !== "undefined" && expandTypeName !== null) ?
                            (expandTypeName.length >= 30 ? expandTypeName.substring(0, 30) + '......' : expandTypeName)
                            : ''
                    }</Tooltip>
                )
            }
        },
        {
            title: '斤两',
            dataIndex: 'amount',
            render: (text: any, record: any) => {
                if (text) {
                    return (
                        <div>{record.amount + " " + record.productUnit.productUnitName}</div>
                    )
                }
            }
        },
        {
            title: '备注',
            dataIndex: 'memo',
            render: (text: any) => {
                return (
                    <Tooltip placement="topLeft" title={text}>{
                        (typeof text !== "undefined" && text !== null) ?
                            (text.length >= 10 ? text.substring(0, 10) + '......' : text)
                            : ''
                    }</Tooltip>
                )
            }
        },
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '需求详情',
        apiId,
        showStates: true,
        columns,
        pagination: true,
        EditComponent: ExpandDetailEdit,
        // mountDataOptions: {
        //     userMount: {
        //         isDept: true
        //     }
        // }
    };

    return (
        <>
            <WebUniversalNewEx props={extendProps} ref={ref}></WebUniversalNewEx>
        </>
    )
}